enum SharepointRootFolders {
  Traffic = '1. Traffic Statistics',
  Forecast = '3. Forecasts',
  Economics = '2. Economics Reports',
  Industry = '5. Airport Industry Reports (AIR)',
  EnvironmentSustainability = '4. Airport Business Studies'
}

export default SharepointRootFolders;
